'use strict';

wbApp.factory('clientSchedulerSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var UserSchedule = $resource('/Api/UserSchedule/:id', {}, {
            'getAllForSemester': { method: 'GET', isArray: true, url: '/Api/UserSchedule/GetAllForSemester' },
            'getUserScheduleDetail': { method: 'GET', url: '/Api/UserSchedule/GetUserScheduleDetail' },
            'setNewAttendance': { method: 'POST', url: '/Api/UserSchedule/SetNewAttendance' }
        });

        function getAllForSemesterAsync(semesterID, compensationGroupID, userID, startDate, endDate) {
            return repositorySvc.customGet('getAllForSemester', UserSchedule, {
                semesterID: semesterID,
                compensationGroupID: compensationGroupID,
                userID: userID,
                startDate: startDate,
                endDate: endDate
            });
        }

        function getUserScheduleDetail(userID, courseScheduleID) {
            return $q(function (resolve, reject) {
                repositorySvc.customGet('getUserScheduleDetail', UserSchedule, {
                    userID: userID,
                    courseScheduleID: courseScheduleID
                }).$promise.then(function (dto) {
                    resolve(new webooker_schedule_models.UserScheduleDetail(dto));
                }, function (rejectReason) {
                    reject(rejectReason);
                });
            });
        }

        function setNewAttendance(userID, courseScheduleID, userScheduleDetail) {
            var studentIDs = userScheduleDetail.getPresentStudentsIDs.call(userScheduleDetail);

            return $q(function (resolve, reject) {
                repositorySvc.customPost(
                    'setNewAttendance',
                    UserSchedule, {
                        userID: userID,
                        courseScheduleID: courseScheduleID,
                        studentIDs: studentIDs
                    },
                    resolve,
                    reject
                )
            });
        }

        return {
            getAllForSemesterAsync: getAllForSemesterAsync,
            getUserScheduleDetail: getUserScheduleDetail,
            setNewAttendance: setNewAttendance
        }
    }]);
